import { LuPiggyBank } from 'react-icons/lu';

import { Card } from '@/components/ui/card';
import { useRequiredParams } from 'utils';
import { cn } from 'utils/cn';

import { summarizePolicyToggle } from './investment-policy-overview';
import { PolicyQueryError } from './PolicyQueryError';
import { usePolicyScope } from './usePolicyScope';

export const PolicyCashEq = () => {
    const { accountGUID, accountGroupGUID } = useRequiredParams(['accountGUID', 'accountGroupGUID']);
    const scope = usePolicyScope(accountGUID, accountGroupGUID);
    const status =
        scope.status === 'ready'
            ? summarizePolicyToggle(scope.accounts.map((item) => item.cashEqSweep))
            : { text: 'Loading…', active: false };

    return (
        <Card className="flex flex-row items-center gap-3.5 rounded-[10px] border-stone-200 px-6 py-[22px] shadow-none">
            <LuPiggyBank
                aria-hidden="true"
                className={cn(
                    'size-8 shrink-0 rounded-md p-2',
                    status.active ? 'bg-stone-900 text-white' : 'text-cocoa-500 bg-stone-100',
                )}
            />
            <div className="min-w-0 flex-1">
                <h3 className="text-cocoa-1000 text-[15px] font-medium">Cash EQ</h3>
                <p className="text-cocoa-500 mt-1 text-sm">
                    Idle available cash is swept into higher-yield equivalents, keeping uninvested cash to a minimum.
                </p>
            </div>
            {scope.status === 'error' ? (
                <PolicyQueryError message="Couldn’t load Cash EQ settings." queries={scope.retryQueries} />
            ) : (
                <span
                    className={cn(
                        'shrink-0 rounded-[5px] px-2 py-1 text-xs font-medium',
                        status.active ? 'bg-[#255C64] text-white' : 'text-cocoa-700 bg-stone-100',
                    )}
                >
                    {status.text}
                </span>
            )}
        </Card>
    );
};
